<template>
    <div>
        <UiModalsSignInModal
            id="sbSignInModal"
            class="sb-modal"
            :blok="blok"
            :form-state="formState"
            @submit="submitForm"
        />
    </div>
</template>

<script lang="ts" setup>
import type { ISignUpFormState } from '@nuxt-monorepo/ui/types/components/modals/SignUpModal';
import type { ISignInModalConfig, ISignInFormData } from '@nuxt-monorepo/ui/types/components/modals/SignInModal';

const props = defineProps<{ blok: ISignInModalConfig }>();

const formState = ref<ISignUpFormState>({
    success: false,
    isSubmitted: false,
    responseMsg: null,
});

const config = useRuntimeConfig();
const { $encodeBase64, $decodeBase64 } = useNuxtApp();
const returnUrl = config?.public.RETURN_URL;
const submitForm = async (formData: ISignInFormData) => {
    formState.value.success = false;
    formState.value.isSubmitted = false;
    formState.value.responseMsg = null;

    await $publicApi('login', {
        method: 'POST',
        body: formData,
        onResponse({ response }) {
            if (response.ok) {
                formState.value.success = true;
                formState.value.isSubmitted = true;
                const redirectSplit = response._data.redirect.split('&return_url=');
                navigateTo(redirectSplit[0] + '&return_url=' + $encodeBase64($decodeBase64(returnUrl) + '/customer'), {
                    external: true,
                });
            }
        },
        onResponseError({ response }) {
            if (response) {
                if (response._data?.errors?.errors?.error?.[0]) {
                    formState.value.responseMsg = response._data.errors.errors.error[0];
                    //@ts-ignore
                } else if (
                    response._data.errors &&
                    //@ts-ignore
                    Object.values(response._data.errors)?.[0].isArray &&
                    //@ts-ignore
                    Object.values(response._data.errors)?.[0]?.[0]
                ) {
                    //@ts-ignore
                    formState.value.responseMsg = Object.values(response._data.errors)?.[0]?.[0];
                } else if (response._data.errors) {
                    //@ts-ignore
                    formState.value.responseMsg = response._data.errors;
                } else if (response._data.message) {
                    formState.value.responseMsg = response._data.message;
                } else {
                    formState.value.responseMsg = props.blok.errorMessage;
                }
                formState.value.success = false;
                formState.value.isSubmitted = true;
            }
        },
    }).catch((err: any) => console.error(err));
};
</script>

<style lang="postcss">
.sb-modal {
    .modal-subtitle {
        @apply font-medium leading-5 tracking-[0.066rem] text-[#5a5e6b] text-sm;
    }
    .modal-dialog {
        .form-input {
            .input-label {
                @apply hidden;
            }
            .error-message {
                @apply mt-1 text-[0.775rem];
            }
        }
        .form-input .form-element {
            @apply leading-tight bg-white bg-clip-padding border h-[50px] text-base font-medium px-3 py-2 rounded-[0.1875rem] border-solid border-[#b9c6d0];
            transition:
                border-color 0.15s ease-in-out,
                box-shadow 0.15s ease-in-out;
        }

        .modal-header {
            @apply bg-secondary max-md:text-white;
            .modal-title {
                @apply max-md:text-[1.2rem] max-md:font-medium;
            }
        }

        .sign-in-button,
        .btn-brand.btn-brand--primary {
            @apply bg-secondary border-secondary text-[1.1rem] tracking-[0.05rem] px-4 py-2 font-bold text-[1.2rem] text-white rounded h-auto;
            &:hover {
                @apply text-white bg-[#3bada4] cursor-pointer border-[#3bada4];
            }
        }

        .link-to-modal {
            @apply text-tertiary-100 font-medium leading-5 tracking-[0.066rem] text-sm;

            &:hover {
            }
        }

        .not-registered-wrapper {
            span {
                @apply font-medium leading-5 tracking-[0.066rem] text-sm;

                span {
                    @apply text-tertiary-100;
                }
            }
        }

        .sign-in-with {
            @apply tracking-[0.066rem] pointer-events-auto leading-[29px] font-semibold text-primary text-[1.1rem] pl-[30px] pr-0 py-0;
            @apply max-md:hidden;
        }

        .or {
            @apply max-md:mb-0;
            img {
                @apply max-md:hidden;
            }
            span {
                @apply max-md:block;
            }
        }

        .social-buttons {
            @apply max-md:flex-row max-md:justify-end;
            a {
                @apply max-md:p-0 max-md:bg-transparent max-md:border-none;
            }
            img {
                @apply max-md:block;
            }
            .social-text {
                @apply max-md:hidden;
            }
        }
    }
}
</style>
